<div class="crud-container">
  <div class="crud-header">
    <div class="crud-title-wrapper">
      <h2>{{ "CRUD.CRUD_SETTINGS" | translate }}</h2>
      <p>{{ "CRUD.SIMPLIFY" | translate }}</p>
    </div>
    <div class="buttons-wrapper">
      <button class="upload">{{ 'COMMON.UPLOAD' | translate}}</button>
      <button data-bs-toggle="modal" data-bs-target="#editAddModal" class="add-new" (click)="onAddNewClicked()">{{ "CRUD.ADD_NEW" | translate }}</button>
    </div>
  </div>
  <div
    [ngClass]="{'crud-filter': selectedSidebarItem == 'CRUD_SETTINGS.CATEGORIES.NETWORK_DEVICE'}"
    *ngIf="currentFilterTemplate && 
    (selectedSidebarItem === 'CRUD_SETTINGS.CATEGORIES.TRANSMISSION_STATION' || selectedSidebarItem == 'CRUD_SETTINGS.CATEGORIES.NETWORK_DEVICE' || selectedSidebarItem == 'CRUD_SETTINGS.CATEGORIES.MAIN_FEEDER' 
    || selectedSidebarItem === 'CRUD_SETTINGS.CATEGORIES.SUB_FEEDER' || selectedSidebarItem === 'CRUD_SETTINGS.CATEGORIES.INJECTION_SUBSTATION' || selectedSidebarItem === 'COMMON.BU.SINGLE'
    || selectedSidebarItem === 'CRUD_SETTINGS.CATEGORIES.DISTRIBUTION_TRANSFORMER' || selectedSidebarItem === 'COMMON.UT.SINGLE' || selectedSidebarItem == 'CRUD_SETTINGS.CATEGORIES.TARIFF'
    || selectedSidebarItem == 'CRUD_SETTINGS.CATEGORIES.METER_TYPE' || selectedSidebarItem === 'CRUD_SETTINGS.CATEGORIES.CUSTOMER_ACCOUNTS')"
  >
    <ng-container *ngTemplateOutlet="currentFilterTemplate"></ng-container>
  </div>
  <div class="crud-body">
    <div class="categories-sidebar">
    <app-crud-sidebar (itemSelected)="onSidebarItemSelected($event)"></app-crud-sidebar>
    </div>

    <div class="crud-content">
      <ng-container [ngSwitch]="selectedSidebarItem">
        <app-crud-section-definitions
         *ngSwitchCase="'CRUD_SETTINGS.CATEGORIES.NETWORK_DEVICE'"
          (filterTemplateReady)="onFilterTemplateReady($event)"
          [refreshTrigger]="refreshKey"
        >
        </app-crud-section-definitions>
        <app-crud-ts
         *ngSwitchCase="'CRUD_SETTINGS.CATEGORIES.TRANSMISSION_STATION'" 
         (filterTemplateReady)="onFilterTemplateReady($event)"
         [refreshTrigger]="refreshKey" #crudTsComponent
        >
        </app-crud-ts>
        <app-crud-f33 
         *ngSwitchCase="'CRUD_SETTINGS.CATEGORIES.MAIN_FEEDER'"
         (filterTemplateReady)="onFilterTemplateReady($event)"
         [refreshTrigger]="refreshKey"
        >
        </app-crud-f33>
        <app-crud-f11 
         *ngSwitchCase="'CRUD_SETTINGS.CATEGORIES.SUB_FEEDER'"
          (filterTemplateReady)="onFilterTemplateReady($event)"
          [refreshTrigger]="refreshKey"
        >
        </app-crud-f11>
        <app-crud-ss 
         *ngSwitchCase="'CRUD_SETTINGS.CATEGORIES.INJECTION_SUBSTATION'"
          (filterTemplateReady)="onFilterTemplateReady($event)"
          [refreshTrigger]="refreshKey"
        >
        </app-crud-ss>
        <app-crud-district 
          *ngSwitchCase="'COMMON.UT.SINGLE'"
          (filterTemplateReady)="onFilterTemplateReady($event)"
          [refreshTrigger]="refreshKey">
        </app-crud-district>
        <app-crud-region 
          *ngSwitchCase="'COMMON.BU.SINGLE'" 
          (filterTemplateReady)="onFilterTemplateReady($event)"
          [refreshTrigger]="refreshKey"
        >
        </app-crud-region>
        <app-crud-dt 
          *ngSwitchCase="'CRUD_SETTINGS.CATEGORIES.DISTRIBUTION_TRANSFORMER'"
          (filterTemplateReady)="onFilterTemplateReady($event)"
          [refreshTrigger]="refreshKey"
        >
        </app-crud-dt>
        <app-crud-meter-type
         *ngSwitchCase="'CRUD_SETTINGS.CATEGORIES.METER_TYPE'"
          (filterTemplateReady)="onFilterTemplateReady($event)"
          [refreshTrigger]="refreshKey"
        >
        </app-crud-meter-type>
        <app-crud-tariff
          *ngSwitchCase="'CRUD_SETTINGS.CATEGORIES.TARIFF'"
          (filterTemplateReady)="onFilterTemplateReady($event)"
          [refreshTrigger]="refreshKey"
        >
        </app-crud-tariff>
        <app-crud-asset-rating
          *ngSwitchCase="'CRUD_SETTINGS.CATEGORIES.ASSET_RATING'"
          (filterTemplateReady)="onFilterTemplateReady($event)"
          [refreshTrigger]="refreshKey"
        >
        </app-crud-asset-rating>
        <app-crud-customer-accounts
          *ngSwitchCase="'CRUD_SETTINGS.CATEGORIES.CUSTOMER_ACCOUNTS'"
          (filterTemplateReady)="onFilterTemplateReady($event)"
          [refreshTrigger]="refreshKey"
        >
        </app-crud-customer-accounts>
      </ng-container>
    </div>
  </div>
</div>